export const workplace_employee = {
    name: 'workplace_employee',
    params: {
        searchFields: ['employee.name']
    }
};
